import { render, staticRenderFns } from "./JianKang_survey.vue?vue&type=template&id=2875ca86&scoped=true"
import script from "./JianKang_survey.vue?vue&type=script&lang=js"
export * from "./JianKang_survey.vue?vue&type=script&lang=js"
import style0 from "./JianKang_survey.vue?vue&type=style&index=0&id=2875ca86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2875ca86",
  null
  
)

export default component.exports